import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import { useGetCountyByIdQuery } from "../../../data/counties/countiesApi";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";
import AutoHoaForm from "./AutoHoaForm";


const UpdateAutoHoa = () => {

    let {hoaId} = useParams();

    const countyByIdApi = useGetCountyByIdQuery(hoaId);
    const [crumbs, setCrumbs] = useState<any[]>([]);

    useEffect(() => {
        let countyObj = countyByIdApi?.data;
        if (countyObj) {
            setCrumbs([
                {content: "Home", url: "/home"},
                {content: "Auto-Hoa", url: "/auto-hoa"},
                {content: "Update Auto-Hoa", url: ""}
            ]);

            document.title = `${countyObj?.name}`;
        }
    }, [countyByIdApi]);

    return (
        <>
            <AutoHoaForm crumbs={crumbs} title={"Update Auto Hoa"} btnText={"Update"}
                        isReadOnly={hasPermission(["AUTOHOA-U"]) === false}/>


        </>
    )
}
export default UpdateAutoHoa;